import { DATE_FORMAT } from '@/main.config'

export const nowMoment = {
  computed: {
    nowMoment() {
      return this.moment().utc()
    },
    nowLocal() {
      return this.moment().local()
    },
    nowFormat() {
      return this.nowMoment.format(DATE_FORMAT[`${this.$store.getters.LOCALE}`])
    },
    nowFormatServer() {
      return this.nowMoment.format(DATE_FORMAT.server)
    }
  }
}
